import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Row, Col, Card, CardBody, Button, Container } from "reactstrap";
import SelectField from "../Utils/SelectField";
import SubscriptionCarousel from "./SubscriptionCarousel";
import AggregateResourceCarousel from "../Customers/AggregateResource";

export default function SubscriptionsAndBalance({
  data,
  fetchCustomerSummaryData,
  aggregateResources,
}) {
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState("");
  const subscriptions = data?.subscriptionList || [];

  const uniqueSubscriptionIds = useMemo(() => {
    if (fetchCustomerSummaryData?.resources) {
      const subscriptionIds = [
        ...new Set(
          fetchCustomerSummaryData?.resources
            ?.filter(
              (resource) => !resource.isAggregate && resource.subscriptionId
            )
            ?.map((resource) => resource.subscriptionId)
        ),
      ];
      return subscriptionIds;
    } else if (subscriptions) {
      const subscriptionIds = [
        ...new Set((subscriptions || [])?.map((sub) => sub.subscriptionId)),
      ];
      return subscriptionIds;
    } else return [];
  }, [fetchCustomerSummaryData, data]);

  const handleSubscriptionChange = (selectedOption) => {
    setSelectedSubscriptionId(selectedOption ? selectedOption.value : "");
    // setActiveIndex(0);
    // setChartKey(prev => prev + 1);
  };

  useEffect(() => {
    if (uniqueSubscriptionIds.length > 0) {
      if (
        !selectedSubscriptionId ||
        !uniqueSubscriptionIds.includes(selectedSubscriptionId)
      ) {
        setSelectedSubscriptionId(uniqueSubscriptionIds[0]);
        // setActiveIndex(0);
        // setChartKey(prev => prev + 1);
      }
    } else {
      setSelectedSubscriptionId("");
    }
  }, [uniqueSubscriptionIds, selectedSubscriptionId]);

  // aggregate sample balance (simple demonstration)
  const aggregateBalance = useMemo(() => {
    const totalMB = 27000;
    const used = Math.round(totalMB * 0.55);
    const remaining = totalMB - used;
    return { totalMB, used, remaining };
  }, [aggregateResources]);

  return (
    <>
      <Row className="align-items-stretch">
        {/* Left: card with carousel (takes 2/3 width on large screens) */}
        <Col
          lg={aggregateResources && aggregateResources?.length > 0 ? 8 : 12}
          md={12}
          sm={12}
          className="mb-3"
        >
          <Card
            className="panel-card h-100"
            style={{ border: "0.1px solid #FD754533", borderRadius: "10px" }}
          >
            <CardBody className="d-flex flex-column h-100">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="customer-title">Active Subscriptions</h5>
                {/* subscription select placeholder */}
                <div className="me-2" style={{ width: "40%" }}>
                  <SelectField
                    id="subscriptionSelect"
                    value={
                      selectedSubscriptionId
                        ? {
                            value: selectedSubscriptionId,
                            label: selectedSubscriptionId,
                          }
                        : null
                    }
                    placeholder="Select Subscription ID"
                    handleChange={handleSubscriptionChange}
                    options={uniqueSubscriptionIds?.map((id) => ({
                      value: id,
                      label: id,
                    }))}
                    isMulti={false}
                  />
                </div>
              </div>

              <SubscriptionCarousel
                subscriptions={subscriptions}
                fetchCustomerSummaryData={fetchCustomerSummaryData}
                selectedSubscriptionId={selectedSubscriptionId}
                aggregateResources={aggregateResources}
              />
            </CardBody>
          </Card>
        </Col>

        {/* Right: Aggregate Balance card */}
        {aggregateResources && aggregateResources?.length > 0 && (
          <Col lg={4} md={12} sm={12} className="mb-3">
            <Card
              className="agg-balance-card  h-100"
              style={{ borderRadius: "10px" }}
            >
              <CardBody className="d-flex flex-column h-100">
                <header className="mb-4 p-2 d-flex justify-content-center align-items-center">
                  <span>
                    <i
                      className="bx bx-data me-2"
                      style={{ fontSize: 28, color: "#fff" }}
                    ></i>{" "}
                  </span>
                  <span className="balance-title">Aggregate Balance</span>
                </header>
                <div className=" mt-2 mb-3">
                  <AggregateResourceCarousel resources={aggregateResources} />
                </div>
              </CardBody>
            </Card>

            {/* <Card
            className="agg-balance-card  h-100"
            style={{ borderRadius: "10px" }}
          >
            <CardBody className="d-flex flex-column h-100">
              <div className="d-flex align-items-start justify-content-between">
                <div>
                  <h5 className="balance-title">
                    {" "}
                    <i
                      className="bx bx-data"
                      style={{ fontSize: 24, color: "#fff" }}
                    ></i>{" "}
                    Aggregate Balance
                  </h5>
                  <div className="balance-number mt-5">
                    {aggregateBalance.remaining.toLocaleString()}
                    <span className="balance-unit">GB</span>
                  </div>
                  <div className="remaining-label">Remaining Data</div>
                </div>
              </div>

              <div className="progress-track mt-3 mb-5">
                <div
                  className="progress-fill"
                  style={{
                    width: `${Math.round(
                      (aggregateBalance.used / aggregateBalance.totalMB) * 100
                    )}%`,
                  }}
                />
              </div>

              <div className="d-flex justify-content-between mt-4 stats-row">
                <div>
                  <div className="stat-label">Total</div>
                  <div className="stat-value">
                    {aggregateBalance.totalMB.toLocaleString()} GB
                  </div>
                </div>
                <div>
                  <div className="stat-label">Used</div>
                  <div className="stat-value">
                    {aggregateBalance.used.toLocaleString()} GB
                  </div>
                </div>
              </div>
            </CardBody>
          </Card> */}
          </Col>
        )}
      </Row>
    </>
  );
}
